import { extra } from "./extra";

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "pt", label: "Português" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "it", label: "Italiano" },
];

export const translations = {
  pt: {
    ...extra.pt,
    "nav.home": "Lar",
    "nav.trade": "Trade",
    "nav.funds": "Fundos",
    "nav.calendar": "Calendário",
    "nav.tools": "Ferramentas",
    "nav.settings": "Configurações",
    "nav.documents": "Documentos",
    "nav.support": "Suporte",
    "nav.info": "Informação",
    "nav.logout": "Sair",
    "nav.dashboard": "Dashboard",
    "nav.demo": "Abrir conta demo",
    "nav.terminal": "Terminal",
    "tab.chart": "Gráfico",
    "tab.assets": "Ativos",
    "tab.history": "Histórico",
    "tab.account": "Conta",
    "terminal.trade": "Trade",
    "terminal.search": "Buscar",
    "terminal.all": "Todos",
    "terminal.selectAsset": "Selecione um ativo",
    "terminal.market": "Mercado",
    "terminal.sell": "Sell",
    "terminal.buy": "Buy",
    "metrics.accountId": "ID da conta",
    "metrics.equity": "Património",
    "metrics.freeMargin": "Margem Livre",
    "metrics.usedMargin": "Margem usada",
    "metrics.openPnl": "P/L Abertos",
    "metrics.balance": "Balanço",
    "metrics.marginLevel": "Nível de Margem",
    "metrics.credit": "Crédito",
    "metrics.leverage": "Alavancagem",
    "positions.open": "Posições Abertas",
    "positions.pending": "Posições Pendentes",
    "positions.closed": "Posições fechadas",
    "positions.asset": "Ativo",
    "positions.side": "Direção",
    "positions.qty": "Qtd.",
    "positions.entry": "Entrada",
    "positions.current": "Atual",
    "positions.close": "Fecho",
    "positions.action": "Ação",
    "positions.closeBtn": "Fechar",
    "positions.volume": "Volume",
    "positions.empty": "Sem posições",
    "positions.closedAt": "Fechada",
    "notifications.title": "Notificações de margem",
    "notifications.empty": "Sem notificações",
    "notifications.stopout": "Stop out iminente · nível de margem",
    "notifications.call": "Margin call · nível de margem",
    "notifications.warn": "Margem baixa · nível de margem",
    "account.title": "Conta",
    "account.deposits": "Depósitos",
    "account.withdrawals": "Retiradas",
    "account.marginLevel": "Nível de margem",
    "docs.title": "Documentos",
    "docs.subtitle": "Verificação de identidade e comprovativo de residência.",
    "docs.document": "Documento",
    "docs.choose": "Escolher documento",
    "docs.noFile": "Nenhum ficheiro escolhido",
    "docs.describe": "Observações",
    "docs.send": "Enviar documento",
    "docs.accepted": "Inf. documentos aceites",
    "docs.id": "Documento de identidade: ID (cartão de cidadão)",
    "docs.passport": "Documento de identidade: Passaporte",
    "docs.residence": "Comprovativo de residência (fatura ou extrato recente)",
    "docs.blocked": "Envio de documentos indisponível. Contacte o suporte ou o seu agente.",
    "info.title": "Informação",
    "info.subtitle": "Conceitos essenciais antes de operar.",
    "settings.title": "Configurações pessoais",
    "settings.language": "Idioma",
    "language.select": "Idioma",
    "demo.title": "Abrir conta demo",
    "demo.subtitle": "Acesso ao MetaTrader em modo demonstração",
    "withdraw.title": "Retirada",
    "withdraw.available": "Disponível",
    "withdraw.request": "Pedir retirada",
    "withdraw.accounts": "Contas de recebimento",
    "withdraw.addAccount": "Adicionar conta",
    "withdraw.history": "Histórico de retiradas",
    "withdraw.amount": "Montante (USD)",
  },
  en: {
    ...extra.en,
    "nav.home": "Home",
    "nav.trade": "Trade",
    "nav.funds": "Funds",
    "nav.calendar": "Calendar",
    "nav.tools": "Tools",
    "nav.settings": "Settings",
    "nav.documents": "Documents",
    "nav.support": "Support",
    "nav.info": "Information",
    "nav.logout": "Log out",
    "nav.dashboard": "Dashboard",
    "nav.demo": "Open demo account",
    "nav.terminal": "Terminal",
    "tab.chart": "Chart",
    "tab.assets": "Assets",
    "tab.history": "History",
    "tab.account": "Account",
    "terminal.trade": "Trade",
    "terminal.search": "Search",
    "terminal.all": "All",
    "terminal.selectAsset": "Select an asset",
    "terminal.market": "Market",
    "terminal.sell": "Sell",
    "terminal.buy": "Buy",
    "metrics.accountId": "Account ID",
    "metrics.equity": "Equity",
    "metrics.freeMargin": "Free Margin",
    "metrics.usedMargin": "Used Margin",
    "metrics.openPnl": "Open P/L",
    "metrics.balance": "Balance",
    "metrics.marginLevel": "Margin Level",
    "metrics.credit": "Credit",
    "metrics.leverage": "Leverage",
    "positions.open": "Open Positions",
    "positions.pending": "Pending Positions",
    "positions.closed": "Closed Positions",
    "positions.asset": "Asset",
    "positions.side": "Side",
    "positions.qty": "Qty.",
    "positions.entry": "Entry",
    "positions.current": "Current",
    "positions.close": "Close price",
    "positions.action": "Action",
    "positions.closeBtn": "Close",
    "positions.volume": "Volume",
    "positions.empty": "No positions",
    "positions.closedAt": "Closed",
    "notifications.title": "Margin notifications",
    "notifications.empty": "No notifications",
    "notifications.stopout": "Stop out imminent · margin level",
    "notifications.call": "Margin call · margin level",
    "notifications.warn": "Low margin · margin level",
    "account.title": "Account",
    "account.deposits": "Deposits",
    "account.withdrawals": "Withdrawals",
    "account.marginLevel": "Margin level",
    "docs.title": "Documents",
    "docs.subtitle": "Identity verification and proof of address.",
    "docs.document": "Document",
    "docs.choose": "Choose document",
    "docs.noFile": "No file selected",
    "docs.describe": "Notes",
    "docs.send": "Send document",
    "docs.accepted": "Accepted documents",
    "docs.id": "Identity document: national ID card",
    "docs.passport": "Identity document: passport",
    "docs.residence": "Proof of address (recent bill or statement)",
    "docs.blocked": "Document upload unavailable. Please contact support or your agent.",
    "info.title": "Information",
    "info.subtitle": "Key concepts before you trade.",
    "settings.title": "Personal settings",
    "settings.language": "Language",
    "language.select": "Language",
    "demo.title": "Open demo account",
    "demo.subtitle": "Access MetaTrader in demo mode",
    "withdraw.title": "Withdrawal",
    "withdraw.available": "Available",
    "withdraw.request": "Request withdrawal",
    "withdraw.accounts": "Receiving accounts",
    "withdraw.addAccount": "Add account",
    "withdraw.history": "Withdrawal history",
    "withdraw.amount": "Amount (USD)",
  },
  es: {
    ...extra.es,
    "nav.home": "Inicio",
    "nav.trade": "Trade",
    "nav.funds": "Fondos",
    "nav.calendar": "Calendario",
    "nav.tools": "Herramientas",
    "nav.settings": "Configuración",
    "nav.documents": "Documentos",
    "nav.support": "Soporte",
    "nav.info": "Información",
    "nav.logout": "Salir",
    "nav.dashboard": "Panel",
    "nav.demo": "Abrir cuenta demo",
    "nav.terminal": "Terminal",
    "tab.chart": "Gráfico",
    "tab.assets": "Activos",
    "tab.history": "Historial",
    "tab.account": "Cuenta",
    "terminal.trade": "Trade",
    "terminal.search": "Buscar",
    "terminal.all": "Todos",
    "terminal.selectAsset": "Seleccione un activo",
    "terminal.market": "Mercado",
    "terminal.sell": "Sell",
    "terminal.buy": "Buy",
    "metrics.accountId": "ID de cuenta",
    "metrics.equity": "Patrimonio",
    "metrics.freeMargin": "Margen libre",
    "metrics.usedMargin": "Margen usado",
    "metrics.openPnl": "P/L abiertos",
    "metrics.balance": "Balance",
    "metrics.marginLevel": "Nivel de margen",
    "metrics.credit": "Crédito",
    "metrics.leverage": "Apalancamiento",
    "positions.open": "Posiciones abiertas",
    "positions.pending": "Posiciones pendientes",
    "positions.closed": "Posiciones cerradas",
    "positions.asset": "Activo",
    "positions.side": "Dirección",
    "positions.qty": "Cant.",
    "positions.entry": "Entrada",
    "positions.current": "Actual",
    "positions.close": "Cierre",
    "positions.action": "Acción",
    "positions.closeBtn": "Cerrar",
    "positions.volume": "Volumen",
    "positions.empty": "Sin posiciones",
    "positions.closedAt": "Cerrada",
    "notifications.title": "Notificaciones de margen",
    "notifications.empty": "Sin notificaciones",
    "notifications.stopout": "Stop out inminente · nivel de margen",
    "notifications.call": "Margin call · nivel de margen",
    "notifications.warn": "Margen bajo · nivel de margen",
    "account.title": "Cuenta",
    "account.deposits": "Depósitos",
    "account.withdrawals": "Retiros",
    "account.marginLevel": "Nivel de margen",
    "docs.title": "Documentos",
    "docs.subtitle": "Verificación de identidad y comprobante de domicilio.",
    "docs.document": "Documento",
    "docs.choose": "Elegir documento",
    "docs.noFile": "Ningún archivo seleccionado",
    "docs.describe": "Observaciones",
    "docs.send": "Enviar documento",
    "docs.accepted": "Documentos aceptados",
    "docs.id": "Documento de identidad: DNI",
    "docs.passport": "Documento de identidad: pasaporte",
    "docs.residence": "Comprobante de domicilio (factura o extracto reciente)",
    "docs.blocked": "Envío de documentos no disponible. Contacte al soporte o a su agente.",
    "info.title": "Información",
    "info.subtitle": "Conceptos esenciales antes de operar.",
    "settings.title": "Configuración personal",
    "settings.language": "Idioma",
    "language.select": "Idioma",
    "demo.title": "Abrir cuenta demo",
    "demo.subtitle": "Acceso a MetaTrader en modo demostración",
    "withdraw.title": "Retiro",
    "withdraw.available": "Disponible",
    "withdraw.request": "Solicitar retiro",
    "withdraw.accounts": "Cuentas de cobro",
    "withdraw.addAccount": "Agregar cuenta",
    "withdraw.history": "Historial de retiros",
    "withdraw.amount": "Importe (USD)",
  },
  fr: {
    ...extra.fr,
    "nav.home": "Accueil",
    "nav.trade": "Trade",
    "nav.funds": "Fonds",
    "nav.calendar": "Calendrier",
    "nav.tools": "Outils",
    "nav.settings": "Paramètres",
    "nav.documents": "Documents",
    "nav.support": "Support",
    "nav.info": "Information",
    "nav.logout": "Déconnexion",
    "nav.dashboard": "Tableau de bord",
    "nav.demo": "Ouvrir un compte démo",
    "nav.terminal": "Terminal",
    "tab.chart": "Graphique",
    "tab.assets": "Actifs",
    "tab.history": "Historique",
    "tab.account": "Compte",
    "terminal.trade": "Trade",
    "terminal.search": "Rechercher",
    "terminal.all": "Tous",
    "terminal.selectAsset": "Sélectionnez un actif",
    "terminal.market": "Marché",
    "terminal.sell": "Sell",
    "terminal.buy": "Buy",
    "metrics.accountId": "ID du compte",
    "metrics.equity": "Capitaux propres",
    "metrics.freeMargin": "Marge libre",
    "metrics.usedMargin": "Marge utilisée",
    "metrics.openPnl": "P/L ouverts",
    "metrics.balance": "Solde",
    "metrics.marginLevel": "Niveau de marge",
    "metrics.credit": "Crédit",
    "metrics.leverage": "Levier",
    "positions.open": "Positions ouvertes",
    "positions.pending": "Positions en attente",
    "positions.closed": "Positions fermées",
    "positions.asset": "Actif",
    "positions.side": "Sens",
    "positions.qty": "Qté",
    "positions.entry": "Entrée",
    "positions.current": "Actuel",
    "positions.close": "Clôture",
    "positions.action": "Action",
    "positions.closeBtn": "Fermer",
    "positions.volume": "Volume",
    "positions.empty": "Aucune position",
    "positions.closedAt": "Fermée",
    "notifications.title": "Notifications de marge",
    "notifications.empty": "Aucune notification",
    "notifications.stopout": "Stop out imminent · niveau de marge",
    "notifications.call": "Appel de marge · niveau de marge",
    "notifications.warn": "Marge faible · niveau de marge",
    "account.title": "Compte",
    "account.deposits": "Dépôts",
    "account.withdrawals": "Retraits",
    "account.marginLevel": "Niveau de marge",
    "docs.title": "Documents",
    "docs.subtitle": "Vérification d'identité et justificatif de domicile.",
    "docs.document": "Document",
    "docs.choose": "Choisir un document",
    "docs.noFile": "Aucun fichier sélectionné",
    "docs.describe": "Remarques",
    "docs.send": "Envoyer le document",
    "docs.accepted": "Documents acceptés",
    "docs.id": "Pièce d'identité : carte d'identité",
    "docs.passport": "Pièce d'identité : passeport",
    "docs.residence": "Justificatif de domicile (facture ou relevé récent)",
    "docs.blocked": "Envoi de documents indisponible. Contactez le support ou votre agent.",
    "info.title": "Information",
    "info.subtitle": "Notions essentielles avant de trader.",
    "settings.title": "Paramètres personnels",
    "settings.language": "Langue",
    "language.select": "Langue",
    "demo.title": "Ouvrir un compte démo",
    "demo.subtitle": "Accès à MetaTrader en mode démo",
    "withdraw.title": "Retrait",
    "withdraw.available": "Disponible",
    "withdraw.request": "Demander un retrait",
    "withdraw.accounts": "Comptes de réception",
    "withdraw.addAccount": "Ajouter un compte",
    "withdraw.history": "Historique des retraits",
    "withdraw.amount": "Montant (USD)",
  },
  it: {
    ...extra.it,
    "nav.home": "Home",
    "nav.trade": "Trade",
    "nav.funds": "Fondi",
    "nav.calendar": "Calendario",
    "nav.tools": "Strumenti",
    "nav.settings": "Impostazioni",
    "nav.documents": "Documenti",
    "nav.support": "Assistenza",
    "nav.info": "Informazioni",
    "nav.logout": "Esci",
    "nav.dashboard": "Dashboard",
    "nav.demo": "Apri conto demo",
    "nav.terminal": "Terminale",
    "tab.chart": "Grafico",
    "tab.assets": "Asset",
    "tab.history": "Storico",
    "tab.account": "Conto",
    "terminal.trade": "Trade",
    "terminal.search": "Cerca",
    "terminal.all": "Tutti",
    "terminal.selectAsset": "Seleziona un asset",
    "terminal.market": "Mercato",
    "terminal.sell": "Sell",
    "terminal.buy": "Buy",
    "metrics.accountId": "ID conto",
    "metrics.equity": "Patrimonio",
    "metrics.freeMargin": "Margine libero",
    "metrics.usedMargin": "Margine usato",
    "metrics.openPnl": "P/L aperti",
    "metrics.balance": "Saldo",
    "metrics.marginLevel": "Livello di margine",
    "metrics.credit": "Credito",
    "metrics.leverage": "Leva",
    "positions.open": "Posizioni aperte",
    "positions.pending": "Posizioni pendenti",
    "positions.closed": "Posizioni chiuse",
    "positions.asset": "Asset",
    "positions.side": "Direzione",
    "positions.qty": "Qtà",
    "positions.entry": "Ingresso",
    "positions.current": "Attuale",
    "positions.close": "Chiusura",
    "positions.action": "Azione",
    "positions.closeBtn": "Chiudi",
    "positions.volume": "Volume",
    "positions.empty": "Nessuna posizione",
    "positions.closedAt": "Chiusa",
    "notifications.title": "Notifiche di margine",
    "notifications.empty": "Nessuna notifica",
    "notifications.stopout": "Stop out imminente · livello di margine",
    "notifications.call": "Margin call · livello di margine",
    "notifications.warn": "Margine basso · livello di margine",
    "account.title": "Conto",
    "account.deposits": "Depositi",
    "account.withdrawals": "Prelievi",
    "account.marginLevel": "Livello di margine",
    "docs.title": "Documenti",
    "docs.subtitle": "Verifica dell'identità e prova di residenza.",
    "docs.document": "Documento",
    "docs.choose": "Scegli documento",
    "docs.noFile": "Nessun file selezionato",
    "docs.describe": "Note",
    "docs.send": "Invia documento",
    "docs.accepted": "Documenti accettati",
    "docs.id": "Documento d'identità: carta d'identità",
    "docs.passport": "Documento d'identità: passaporto",
    "docs.residence": "Prova di residenza (bolletta o estratto recente)",
    "docs.blocked": "Invio documenti non disponibile. Contatta il supporto o il tuo agente.",
    "info.title": "Informazioni",
    "info.subtitle": "Concetti essenziali prima di operare.",
    "settings.title": "Impostazioni personali",
    "settings.language": "Lingua",
    "language.select": "Lingua",
    "demo.title": "Apri conto demo",
    "demo.subtitle": "Accesso a MetaTrader in modalità demo",
    "withdraw.title": "Prelievo",
    "withdraw.available": "Disponibile",
    "withdraw.request": "Richiedi prelievo",
    "withdraw.accounts": "Conti di ricezione",
    "withdraw.addAccount": "Aggiungi conto",
    "withdraw.history": "Storico prelievi",
    "withdraw.amount": "Importo (USD)",
  },
};
